import PropTypes from "prop-types";
import {Box, CircularProgress, Tooltip, Typography, useTheme} from "@mui/material";

const InfoBox = (props) => {
    const theme = useTheme()
    const boxComponent = (
        <Box alignItems='center'
             ml='1.5em'
             display='inline-flex'
             color={theme.palette.common.black}
             onClick={props.onClick}>
            {props.icon}
            <Box borderRadius='0.5em'
                 bgcolor='white'
                 border='2px solid rgba(0,0,0,0.2)'
                 padding='8px 48px'
                 display='flex'>
                {!props.loading ?
                    <Typography variant="button"
                                onClick={props.onClick}
                                color={theme.palette.common.black}
                                maxWidth='150px'
                                display='block'
                                whiteSpace='nowrap'
                                overflow='hidden'
                                textOverflow='ellipsis'>
                        {props.label}
                    </Typography> :
                    <CircularProgress size={24}/>}
            </Box>
        </Box>
    )
    return (
        <Tooltip title={props.label} arrow>
            {boxComponent}
        </Tooltip>
    );
}

InfoBox.propTypes = {
    loading: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.element.isRequired,
}

InfoBox.defaultProps = {
    loading: false
}

export default InfoBox
